import {RemoteGetTeaForm} from 'data/usecases/private/tea-form';
import {GetTeaForm} from 'domain/usecases/private/tea-flow';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {TeaFormFlowEndpoints} from 'main/factories/usecases/endpoints';

export const makeGetTeaForm = (): GetTeaForm =>
	new RemoteGetTeaForm(
		makeBFFApiUrl(TeaFormFlowEndpoints.teaForm),
		makeAuthorizeHttpClientDecorator(),
	);
